import React from 'react';

import Icon from '@ant-design/icons/lib/components/Icon';

import { ReactComponent as CheckCricleSVG } from '../../../../../../assets/sightx-icons/svg/sx-check-circle.svg';

import styles from './index.module.scss';

interface IModalBulletProps {
  content: string;
}

export const ModalBullet: React.FunctionComponent<IModalBulletProps> = ({ content }) => {
  return (
    <div className={styles.bullet}>
      <Icon component={CheckCricleSVG} />
      <label>{content}</label>
    </div>
  );
};